// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"2c004ea1","304":"2c186e9b","310":"5f09405c","387":"46345567","742":"10abb2da","779":"aa36ab00","856":"35bda0b9"}[chunkId] + ".chunk.js";
};